import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  if (localStorage.getItem("cast_kid")) cfg.headers["X-Cast-Kid"] = "1";
  return cfg;
});

let refreshing: Promise<any> | null = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const url = cfg.url || "";
    if (err.response?.status === 401 && !cfg._retry && !url.includes("/auth/refresh") && !url.includes("/auth/login")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e: any): string {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x?.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return String(d?.msg || d);
}

export const kjvUrl = (ref: string) => `https://www.biblegateway.com/passage/?search=${encodeURIComponent(ref)}&version=KJV`;

export function timeAgo(isoStr: string) {
  const s = (Date.now() - new Date(isoStr).getTime()) / 1000;
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 604800) return `${Math.floor(s / 86400)}d ago`;
  return new Date(isoStr).toLocaleDateString();
}
